export const vk_id = 8083625;